import Block from "./block";
import classNames from "classnames";

export default function HiddenBlock(props) {
    return (
        <Block
            isHiddenBlock={true}
            {...props}
            className={classNames(
                "bg-gray-100 border-2 border-dashed border-gray-400 text-center",
                "text-gray-600 text-sm italic backdrop-blur-sm",
                props.classname
            )}
        >
            <div className="max-w-lg mx-auto section relative z-10 opacity-80">
                <h3 className="text-base font-semibold mb-2 text-gray-700">
                    {props?.values?.title ? `${props?.values?.title} block hidden` : "Block hidden"}
                </h3>
                <p className="text-sm text-gray-500">
                    {props?.emptyMessage || "Because there are no items assigned or available, this block will be hidden from visitors on the live website. You can still edit or update it here in the builder."}
                </p>
            </div>
        </Block>
    );
}
